import { render, staticRenderFns } from "./PayoutRule.vue?vue&type=template&id=97c34d28&scoped=true"
import script from "./PayoutRule.vue?vue&type=script&lang=js"
export * from "./PayoutRule.vue?vue&type=script&lang=js"
import style0 from "./PayoutRule.vue?vue&type=style&index=0&id=97c34d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c34d28",
  null
  
)

export default component.exports